// query-keys/job-keys.js
import { queryClient } from "utils/react-query";

const collection = "milestones";

export const milestoneKeys = {
  // Base keys
  all: [collection],
  count: (id) => [...milestoneKeys.all, "count", id],
  details: () => [...milestoneKeys.all, "detail"],
  detail: (id) => [...milestoneKeys.details(), id],
  

  allocatedSum: (id) => [...milestoneKeys.all, "allocated", id],
  allApprovedHours: (id, dateRange) => [...milestoneKeys.all, "approved", id, dateRange],
  allLoggedHours: (id, dateRange) => [...milestoneKeys.all, "logged", id, dateRange],
};

export function invalidateJobQueries() {
  const predicates = [
    // Invalidate all job lists
    ({ queryKey }) => queryKey[0] === collection && queryKey[1] === "list",
  ];

  predicates.forEach((predicate) => {
    queryClient.invalidateQueries({ predicate });
  });
}

// Additional helper for invalidating all job queries
export function invalidateAllJobQueries() {
  queryClient.invalidateQueries({
    predicate: ({ queryKey }) => queryKey[0] === collection,
  });
}
